import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  isLoadingDetails: false,
  isLoadingDetailsCount: 0,
  error: null,
  data: {
    data_extensions: null,
    details: null,
    selected: null,
    status: null
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_DATA_EXTENSIONS:
      return { ...state, isLoading: true };
    case Constants.REQUEST_DATA_EXTENSION_COLUMNS:
      const requestCount = state.isLoadingDetailsCount + 1;
      return {
        ...state,
        isLoading: true,
        isLoadingDetails: true,
        isLoadingDetailsCount: requestCount,
        data: {
          ...state.data,
          details: null
        }
      };
    case Constants.RECEIVE_DATA_EXTENSIONS:
      if (action.error) {
        return {
          ...state,
          isLoading: false,
          error: action.error
        };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          ...action.data
        }
      };
    case Constants.RECEIVE_DATA_EXTENSION_COLUMNS:
      let receiveCount = state.isLoadingDetailsCount - 1;
      if (receiveCount < 0) {
        receiveCount = 0;
      }
      if (action.error) {
        return {
          ...state,
          isLoading: false,
          isLoadingDetails: receiveCount > 0,
          isLoadingDetailsCount: receiveCount,
          error: action.error
        };
      }
      const data = action.data || {};
      return {
        ...state,
        isLoading: false,
        isLoadingDetails: receiveCount > 0,
        isLoadingDetailsCount: receiveCount,
        data: {
          ...state.data,
          details: data
        }
      };
    case Constants.REQUEST_CREATE_DATA_EXTENSION_IMPORT:
      return {
        ...state,
        data: {
          ...state.data,
          selected: action.selectedDataExtension,
          importNow: null
        },
        isLoading: true
      };
    case Constants.CLEAR_DATA_EXTENSION_STATUS:
      return {
        ...state,
        data: {
          ...state.data,
          status: undefined
        }
      };
    case Constants.RECEIVE_CREATE_DATA_EXTENSION_IMPORT:
      if (action.error) {
        return {
          ...state,
          isLoading: false,
          error: action.error,
          importCreateError: action.error
        };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          status: action.data.status,
          profile_changes: action.data.profile_changes,
          importNow: action.data.importNow
        }
      };
    default:
      return state;
  }
}
